import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          <h1 className="App-title">Luke Phelan</h1>
        </header>
        <p className="App-intro">
            <a href="https://www.linkedin.com/in/lukegphelan/" target="_blank">LinkedIn</a>
            <br/>
            <a href="https://github.com/lukephelan" target="_blank">GitHub</a>
            <br/>
            <a href="mailto:luke@lukephelan.com">Email</a>
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js